
export class SpringFollower {
  constructor(element, attributeName, options = {}) {
    this.element = element
    this.attributeName = attributeName
    this.target = 0
    this.current = 0
    this.velocity = 0
    this.wholeNumbers = options.wholeNumbers || true

    this.config = {
      stiffness: options.stiffness || 300,
      damping: options.damping || 20,
      mass: options.mass || 1,
      precision: options.precision || 0.01
    }
    
    this.animation = null
    this.isAnimating = false
  }
  
  setTarget(newTarget) {
    this.target = parseInt(newTarget);
    
    // Start animation if not already running
    if (!this.isAnimating) {
      this.startAnimation()
    }
  }
  
  startAnimation() {
    this.isAnimating = true
    
    const tick = (deltaTime) => {

      // Spring physics calculation
      const delta = this.target - this.current
      const springForce = delta * this.config.stiffness
      const dampingForce = this.velocity * this.config.damping
      const acceleration = (springForce - dampingForce) / this.config.mass

      // Update velocity and position
      this.velocity += acceleration * (deltaTime / 1000)
      this.current += this.velocity * (deltaTime / 1000)

      // Update the element
      this.element.setAttribute(this.attributeName, Math.round(this.current), delta);

      // Stop if settled
      if (isNaN(this.current) || Math.abs(delta) < this.config.precision && Math.abs(this.velocity) < this.config.precision) {
        this.current = this.target
        this.velocity = 0
        this.element.setAttribute(this.attributeName, this.current)
        this.isAnimating = false
        return // Stop the animation
      }
      
      return true // Continue animating
    }
    
    const loop = () => {
        const currentTime = performance.now();
        const deltaTime = currentTime - (this.lastTime || currentTime);
        this.lastTime = currentTime;

        const shouldContinue = tick(deltaTime)
        
        if (shouldContinue) {
            requestAnimationFrame(loop)
        }
    }

    requestAnimationFrame(loop);
  }
}

